import {useEffect, useState} from 'react';
import Alert from '../../components/layout/Alert';
import {cnpj, cpf} from 'cpf-cnpj-validator';
import api from '../../services/api';
import Spinner from '../../components/button/Spinner';
import {Link, useLocation, useNavigate} from 'react-router-dom';


const Forgot = () => {
    const [document, setDocument] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [alertColor, setAlertColor] = useState('red');
    const [alertMessage, setAlertMessage] = useState('');
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const isRegister = location.pathname.search('register') !== -1;
    const navigate = useNavigate();

    useEffect(() => {
        if (document !== undefined && document.trim() !== '') {
            const numberPattern = /\d+/g;
            let documentNumbers = document.match(numberPattern);
            if (documentNumbers !== null) {
                setDocument(documentNumbers.join(''));
            } else {
                setDocument('');
                return;
            }
            documentNumbers = documentNumbers.join('');
            if (documentNumbers.length === 11) {
                setDocument(cpf.format(document));
                return;
            }
            setDocument(cnpj.format(document));
        }
    }, [document]);

    const handleRegister = () => {
        if (isRegister && !cpf.isValid(document)) {
            if (!cnpj.isValid(document)) {
                setAlertMessage('Documento invalido');
                setShowAlert(true);
                return;
            }
        }

        setLoading(true);
        setShowAlert(false);
        api
            .post((isRegister ? 'register' : 'password/forgot'), {
                email: email,
                document: document,
            })
            .then(() => {
                setEmail('');
                setDocument('');
                setAlertColor('')
                setAlertMessage('Olá, Enviamos um e-mail para você recadastrar sua senha, favor conferir."');
                setShowAlert(true);
                setAlertColor('blue')
                setTimeout(() => {
                    setAlertColor('red');
                }, 5000);
            })
            .catch((err) => {
                setShowAlert(true);
                if (err.response.status) {
                    if (err.response.status === 422) {
                        if (err.response.data.errors) {
                            const errors = err.response.data.errors;
                            if (isRegister && errors[Object.keys(errors)[0]][0] === 'O campo documento já está sendo utilizado.') {
                                setAlertMessage('Olá, CNPJ já cadastrado, favor clicar em voltar e após em recuperar a senha. Obrigado!');
                            } else {
                                setAlertMessage(errors[Object.keys(errors)[0]][0]);
                            }
                        } else {
                            setAlertMessage(err.response.data.message);
                        }

                        return;
                    }
                }
                setAlertMessage('Erro ao enviar dados');
                console.error(err);
            })
            .finally(() => setLoading(false));
    };

    return (
        <>
            <div className="m-auto bg-white rounded-md content-center w-full space-y-8 text-center">
                <form
                    className="content-center space-y-5 pt-7"
                    method="POST"
                    onSubmit={function (e) {
                        e.preventDefault();
                        handleRegister();
                    }}
                >
                            <span className="text-zinc-600 text-3xl font-semibold">
                                {isRegister ? 'Primeiro acesso' : 'Recuperar senha'}
                            </span>
                    <div className="rounded-md shadow-sm">
                        <input
                            id="document-address"
                            name="document"
                            type="text"
                            value={document}
                            autoComplete="document"
                            required
                            className="mb-5 appearance-none w-3/4 px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                            placeholder="CPF/CNPJ"
                            onChange={(e) => {
                                setDocument(e.target.value);
                            }}
                        />
                        <input
                            id="email-address"
                            name="email"
                            type="email"
                            value={email}
                            autoComplete="current-password"
                            required
                            className="mb-5 appearance-none w-3/4 px-3 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                            placeholder="Email"
                            onChange={(e) => {
                                setEmail(e.target.value);
                            }}
                        />
                    </div>
                    <button
                        type="submit"
                        className="bg-blue-500 font-bold text-white  relative
                             w-3/4 flex justify-center py-2 px-4 border border-transparent text-sm
                             font-medium rounded-md  hover:bg-blue-600 focus:outline-none focus:ring-2
                             focus:ring-offset-2 focus:ring-indigo-500 m-auto"
                    >
                        <span className="absolute left-0 inset-y-0 flex items-center pl-3"/>
                        Enviar
                    </button>
                        <Alert
                            alertOpen={setShowAlert}
                            show={showAlert}
                            color={alertColor}
                            message={alertMessage}
                        />
                    <Link to="/" onClick={(e) => {
                        e.preventDefault();
                        navigate(-1);
                    }}
                          className="block underline font-medium text-blue-500 hover:text-blue-900 pb-7">
                        Voltar
                    </Link>
                    <Spinner loading={loading}/>
                </form>
            </div>
        </>
    );
};
export default Forgot;
